import { observer } from 'mobx-react';
import React, { useCallback } from 'react';

import { useStores } from 'core';
import { DataGrid, DataGridSorting, ManagedPaginationButtons } from 'shared/components/other';
import { toServerSorting } from 'helpers';
import { SortingOptions } from 'types';
import { columns } from './LogTable.columns';
import { convertToTableRows } from './LogTable.helpers';
import classes from './LogTable.module.scss';

// Adapter to convert DataGridSorting to SortingOptions
const convertToSortingOptions = (sorting: DataGridSorting): SortingOptions => {
  if (!sorting) return null;
  return {
    field: sorting.columnKey,
    direction: sorting.direction === 'asc' ? 'ASC' : 'DESC',
  };
};

// Adapter to convert SortingOptions to DataGridSorting
const convertToDataGridSorting = (sorting: SortingOptions): DataGridSorting => {
  if (!sorting) return null;
  return {
    columnKey: sorting.field,
    direction: sorting.direction === 'ASC' ? 'asc' : 'desc',
  };
};

export const LogTable: React.VFC = observer(() => {
  const { adFoxLogStore: log } = useStores();

  const rows = convertToTableRows(log.data);

  const handleSortingChange = useCallback(
    (value: DataGridSorting) => {
      log.setSorting(toServerSorting(convertToSortingOptions(value)));
    },
    [log],
  );

  return (
    <div className={classes.root}>
      <DataGrid
        columns={columns[log.type]}
        rows={rows}
        headerRowHeight={50}
        initialSorting={convertToDataGridSorting(log.defaultSorting)}
        onSortingChange={handleSortingChange}
      />
      <div className={classes.pagination}>
        <span className={classes.info}>Общее количество записей: {log.totalItems}</span>
        <ManagedPaginationButtons pagination={log} />
      </div>
    </div>
  );
});
